export default [
  {
    path: '/epad/:id',
    name: 'epad',
    component: () => import('@/views/cloudfit/epad/Epad.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/pt-detail/:id',
    name: 'pt-detail',
    component: () => import('@/views/cloudfit/package/Pt_Detail.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/cloudfit/calendar/Calendar.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/member-list',
    name: 'member-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/staff-list',
    name: 'staff-list',
    component: () => import('@/views/cloudfit/staff/staff_list.vue'),
    meta: {
      pageTitle: 'User List 系統用戶管理',
      breadcrumb: [
        {
          text: 'User List 系統用戶管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/staff/edit/:id',
    name: 'apps-staff-edit',
    component: () => import('@/views/cloudfit/staff/staff-edit/StaffEdit.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/cloudfit/package/:id',
    name: 'apps-package',
    component: () => import('@/views/cloudfit/package/Package.vue'),
    meta: {
      pageTitle: 'Package Record',
      breadcrumb: [
        {
          text: 'Package Record',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/edit/:id',
    name: 'apps-member-edit',
    component: () => import('@/views/cloudfit/member/member-edit/MemberEdit.vue'),
    meta: {
      pageTitle: 'Member Info 個人資料',
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/:id/invoice/add/',
    name: 'apps-member-inovice-add',
    component: () => import('@/views/cloudfit/member/invoice/invoice-add.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/:id/membership/add/',
    name: 'apps-member-membership-add',
    component: () => import('@/views/cloudfit/member/membership/add.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/news-list',
    name: 'news-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/package-list',
    name: 'package-list',
    component: () => import('@/views/cloudfit/package/package_list.vue'),
    meta: {
      pageTitle: 'Package List 套票管理',
      breadcrumb: [
        {
          text: 'Package List 套票管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/class-import',
    name: 'class-import',
    component: () => import('@/views/cloudfit/class/Import.vue'),
    meta: {
      pageTitle: 'Import',
      breadcrumb: [
        {
          text: 'Import',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/system-config',
    name: 'system-config',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/class-list',
    name: 'class-list',
    component: () => import('@/views/cloudfit/class/Class.vue'),
    meta: {
      pageTitle: 'Class List 課堂管理',
      breadcrumb: [
        {
          text: 'Class List 課堂管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: () => import('@/views/cloudfit/product/product.vue'),
    meta: {
      pageTitle: 'Product List 貨品管理',
      breadcrumb: [
        {
          text: 'Product List 貨品管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/coupon-list',
    name: 'coupon-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/center-list',
    name: 'center-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/room-list',
    name: 'room-list',
    component: () => import('@/views/cloudfit/room/Room.vue'),
    meta: {
      pageTitle: 'Room List 課室管理',
      breadcrumb: [
        {
          text: 'Room List 課室管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/:code',
    name: 'report',
    component: () => import('@/views/cloudfit/report/Report.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-transacion',
    name: 'report-transacion',
    component: () => import('@/views/cloudfit/report/Report-transaction.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-nonpay',
    name: 'report-nonpay',
    component: () => import('@/views/cloudfit/report/Report-nonpay.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-personal-training',
    name: 'report-personal-training',
    component: () => import('@/views/cloudfit/report/Report-pt.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/expenditure',
    name: 'expenditure',
    component: () => import('@/views/cloudfit/expenditure/expenditure-list.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('@/views/cloudfit/invoice/invoice-list.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
]
